function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1.984 3.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M106.542 115.462a.3.3 0 0 1 .184-.275.3.3 0 0 1 .389.161.295.295 0 0 1-.065.324.297.297 0 0 1-.508-.21zm1.39 0a.298.298 0 1 1 .595 0 .298.298 0 0 1-.596 0m-1.39 1.288a.3.3 0 0 1 .184-.275.3.3 0 0 1 .389.16.295.295 0 0 1-.065.325.297.297 0 0 1-.508-.21zm1.39 0a.298.298 0 1 1 .595 0 .298.298 0 0 1-.596 0m-1.39 1.292a.3.3 0 0 1 .184-.275.3.3 0 0 1 .389.16.295.295 0 0 1-.065.325.297.297 0 0 1-.508-.21zm1.39 0a.298.298 0 1 1 .595 0 .298.298 0 0 1-.596 0",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-106.542 -115.164)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHandle);
export default __webpack_public_path__ + "static/media/dragHandle.8b0cf41dc4cd9c188be1329b50d15adc.svg";
export { ForwardRef as ReactComponent };